import { Component, Input, OnInit } from '@angular/core';

import { provideParent, UnitOfWork } from '../../services/common';
import { EditPropParent } from '../../controls/common';

import { TypeCremeVersion } from '../../entities/EntityModels';

@Component({
    selector: 'type-creme-version-editor',
    templateUrl: './type-creme-version-editor.html',
    providers: [provideParent(TypeCremeVersionEditorComponent, EditPropParent)]
})
export class TypeCremeVersionEditorComponent implements OnInit, EditPropParent {
    @Input() entity: TypeCremeVersion;

    constructor(public uow: UnitOfWork) {

    }

    ngOnInit() {
    }

    getError(propName: string) {
        if (this.entity == null) {
            return;
        }

        const err = this.entity.getErrorFor(propName);
        if (err) {
            return err;
        }
        return null;
    }
}
